import React, { createContext, useContext, useMemo, useState, useEffect } from 'react'
import { useAuthDataContext } from './Auth'
import Api from '../_helpers/Api'
import { useSocketContext } from './Socket'
import sound from '../assets/voice-2.ogg'

export const NotificationsContext = createContext({})

const NotificationsProvider = props => {

    const auth = useAuthDataContext();
    const listener = useSocketContext();
    const userId = auth.id();
    const partnerId = auth.partnerId();

    const audio = new Audio(sound);

    const [state, setState] = useState({
        latest: null,
        list: [],
        page: 1,
        pages: 0,
        count: 0,
        hasMore: true
    });

    const load = (page = 1) => {
        Api.get('notifications/get?page=' + page)
            .then(res => {
                const itemsWithKey = res.data.items.map((item, i) => ({
                    ...item,
                    _key: `notif-${item.id}-${item.type || ''}-${i}`
                }));
                setState(prev => ({
                    ...prev,
                    list: [...prev.list, ...itemsWithKey],
                    page: page,
                    pages: res.data.pages,
                    hasMore: res.data.has_more
                }));
            })
    }

    const loadCount = () => {
        Api.get('notifications/total')
            .then(res => {
                setState(prev => ({
                    ...prev,
                    count: res.data
                }))
            });
    }

    const add = text => {
        let data = {
            id: Math.random().toString(),
            text: text,
            _key: `notif-${Math.random().toString(36).substring(2)}-${Date.now()}`
        }

        setState(prev => ({
            ...prev,
            latest: data
        }));
    }

    const clear = () => {
        setState(prev => ({
            ...prev,
            list: [],
            count: 0,
        }));
    }

    useEffect(() => {

        if (!userId || !listener) return;

        load();
        loadCount();

        const userChannel = auth.isEmployee()
            ? `App.Models.Employee.${userId}`
            : `App.Models.Administrator.${userId}`;

        console.log('[Notifications] Subscribing to channel:', userChannel);

        listener.private(userChannel)
            .notification(notification => {
                console.log('[Notifications] Received notification:', notification);
                const notificationWithKey = {
                    ...notification,
                    text: notification.text || notification.message,
                    _key: `notif-${notification.id}-${notification.type || ''}-${Date.now()}`
                };
                setState(prev => ({
                    ...prev,
                    list: [notificationWithKey, ...prev.list],
                    count: prev.count + 1,
                    latest: notificationWithKey,
                }));

                audio.current.play().catch(() => {});
            });

        if (auth.isEmployee()) {
            listener.private(userChannel)
                .listen('EmployeeUpdated', () => {
                    auth.refresh();
                });
            listener.private(`partners.${partnerId}`)
                .listen('PartnerUpdated', () => {
                    auth.refresh();
                });
        }

    }, [userId]);

    const data = useMemo(() => ({
        ...state, load, loadCount, add, clear
    }), [state]);

    return <NotificationsContext.Provider value={data} {...props} />
}

export const useNotificationsContext = () => useContext(NotificationsContext);

export default NotificationsProvider;